import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { ModBoss } from '@vp/mod-father';
import { uxModsSelectors } from '../../state/uxMods';
import { modfatherTracker as hostTracker } from '../../apis/trackingApi';
import { useHostControlsV1Library } from '../../hooks/modLibraryHooks/useHostControlsV1Library';
import { PageModsContext } from '../contexts/PageModsContext';

export const ItemModWrapper = ({ itemId, children }) => {
  const mods = useSelector(state =>
    uxModsSelectors.selectModsByItemId(state.uxMods, itemId)
  );
  const { activeItemLevelPageUxMods: pageUxMods } = useContext(PageModsContext);

  const lineItemEnvironmentData = useSelector(state =>
    uxModsSelectors.selectItemEnvironmentDataByItemId(state.uxMods, itemId)
  );

  const cartData = useSelector(state =>
    uxModsSelectors.selectCartEnvironmentData(state.uxMods)
  );

  const envData = {
    ...cartData,
    ...lineItemEnvironmentData,
  };

  const dispatch = useDispatch();
  const libraries = {
    hostControlsV1: useHostControlsV1Library(dispatch),
  };

  return (
    <ModBoss
      mods={[...(pageUxMods || []), ...(mods || [])]}
      environmentData={envData}
      contextKey={itemId}
      hostTracker={hostTracker}
      libraries={libraries}
    >
      {children}
    </ModBoss>
  );
};

ItemModWrapper.propTypes = {
  itemId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
